import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    setTimeout(() => this.fadeOut(), 4000) //milliseconds
  }

  fadeOut() {
    this.element.classList.remove("fadeInRight")
    this.element.classList.add("fadeOutRight")
  }
}
